<template>
  <div id="contenedor-contrato-estimaciones-default">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <!-- Boton para generar excel de estimaciones. -->
      <exportar-excel-estimaciones
      :contrato="getContrato"
      :estimaciones="getEstimaciones">
      </exportar-excel-estimaciones>
      <!-- Boton para generar excel de finiquito. -->
      <exportar-excel-finiquito
        :contrato="getContrato"
        :catalogoConceptos="getCatalogoConceptos"
        :estimaciones="getEstimaciones"
        :firmas="getFirmasActivas">
      </exportar-excel-finiquito>
      <custom-button
        v-if="!soloLectura && mixValidaScopesActions(1)"
        label="Nueva"
        iconText="mdi-plus"
        tipo="agregar"
        @click="mostrarRegistrarNuevaEstimacion = !mostrarRegistrarNuevaEstimacion"
      >
      </custom-button>
    </v-toolbar>
    <v-toolbar
      v-if="!$vuetify.breakpoint.mobile"
      flat>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="tipoLista" class="mr-2" borderless>
        <v-btn small>
          <v-icon> mdi-table-merge-cells </v-icon>
        </v-btn>
        <v-btn small>
          <v-icon> mdi-table-split-cell </v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    ></v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :estimaciones="getEstimaciones"
      :conceptos="getCatalogoConceptosPartidas"
      :contrato="getContrato"
      :firmas="getFirmasActivas"
      :programasobra="getContratoPrograma"
      :es-obra-financiada="getContrato.esObraFinanciada"
      :solo-lectura="soloLectura"
    >
    </listado>
    <!-- Registrar nueva estimacion -->
    <v-dialog
      v-model="mostrarRegistrarNuevaEstimacion"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="d-print-none">
          NUEVA ESTIMACION
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.registrarNuevaEstimacion.cerrar()">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <registrar-nueva-estimacion
            v-if="programa && mostrarRegistrarNuevaEstimacion"
            ref="registrarNuevaEstimacion"
            :contrato="getContrato"
            :estimaciones="getEstimaciones"
            :programa="programa"
            @cerrar="cerrar"
          >
          </registrar-nueva-estimacion>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cancelar"
            @click="$refs.registrarNuevaEstimacion.cerrar()"
          >
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.registrarNuevaEstimacion.guardar()"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Editar estimacion -->
    <v-dialog
      v-model="mostrarEditarEstimacion"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="d-print-none">
          EDITAR ESTIMACION
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.editarEstimacion.cerrar()">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-estimacion
            v-if="programa && estaEstimacion"
            ref="editarEstimacion"
            :estimacion-editar="estaEstimacion"
            :contrato="getContrato"
            :estimaciones="getEstimacionesAntesDeLaUltima"
            :programa="programa"
            @cerrar="cerrar"
          >
          </editar-estimacion>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cancelar"
            @click="$refs.editarEstimacion.cerrar()"
          >
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.editarEstimacion.mixActualizar()"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- GRAFICA ESTIMADO ACUMULADO -->

    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarEstimadoAcumulado"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          ANÁLISIS DEL ESTIMADO ACUMULADO - ESTIMACIÓN {{estaEstimacion.numero}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarEstimadoAcumulado = !mostrarEstimadoAcumulado"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <grafica-estimado-acumulado
          ref="graficaEstimadoAcumulado"
          :estimacion="estaEstimacion"
          :estimaciones="estimaciones"
          :contrato="getContrato"
          :convenios="getConveniosModificatorios"
          @generando="generandoGraficaEstimadoAcumulado"
          @terminando="terminandoGraficaEstimadoAcumulado">

          </grafica-estimado-acumulado>
        </v-card-text>

        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.graficaEstimadoAcumulado.generarPdf()"
            :loading="generandoPdfGraficaEstimadoAcumulado"
          >
          <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- PROGRAMA DE OBRA para la Estimación -->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarProgramaObraEstimaciones"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          ESTIMACIÓN {{estaEstimacion.numero}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarProgramaObraEstimaciones = !mostrarProgramaObraEstimaciones"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <programa-obra-estimaciones
          :estimacion="estaEstimacion"
          :contrato="getContrato">

          </programa-obra-estimaciones>
        </v-card-text>
        <v-card-actions class="d-print-none"
        >
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- grafica AVANCE ESTIMACIONES -->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarGraficaAvanceEstimaciones"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          GRAFICA DE AVANCE FINANCIERO PROGRAMADO VS REAL - ESTIMACIÓN {{estaEstimacion.numero}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarGraficaAvanceEstimaciones = !mostrarGraficaAvanceEstimaciones"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <grafica-avance-estimaciones
            ref="graficaAvanceEstimaciones"
            :estimacion="estaEstimacion"
            :contratoEstimaciones="getEstimaciones"
            :contrato="getContrato"
            :programasobra="getContratoPrograma"
            :firmas="getFirmasActivas"
            @generando="generandoGraficaAvanceEstimaciones"
            @terminando="terminandoGraficaAvanceEstimaciones"
            @mostrarGrafica="mostrarGrafica">
          </grafica-avance-estimaciones>
        </v-card-text>
        <v-card-actions class="d-print-none"
        v-if="activarMostrarGrafica">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.graficaAvanceEstimaciones.generarPdfGraficaAvance()"
            :loading="generandoPdfGraficaAvanceEstimaciones"

          >
          <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reporte CONTROL ESTIMACIONES -->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarReporteControlEstimaciones"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          CONTROL DE ESTIMACIONES
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarReporteControlEstimaciones = !mostrarReporteControlEstimaciones"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reporte-control-estimaciones
            ref="reporteControlEstimaciones"
            :estimacion="estaEstimacion"
            :estimaciones="getEstimaciones"
            :contrato="getContrato"
            :firmas="getFirmasActivas"
            @generando="generandoControlEstimaciones"
            @terminando="terminandoControlEstimaciones"
          >
          </reporte-control-estimaciones>
        </v-card-text>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.reporteControlEstimaciones.generarPdfControl()"
            :loading="generandoPdfControlEstimaciones"

          >
          <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Reporte CONCENTRADO ESTIMACIONES -->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarReporteConcentradoEstimaciones"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          CONTRATOS DE OBRA
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarReporteConcentradoEstimaciones = !mostrarReporteConcentradoEstimaciones"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reporte-concentrado-estimaciones
            ref="reporteConcentradoEstimaciones"
            :estimacion="estaEstimacion"
            :contrato="getContrato"
            :firmas="getFirmasActivas"
            @generando="generandoConcentradoEstimaciones"
            @terminando="terminandoConcentradoEstimaciones"
            @generandoDetalle="generandoDetalleConcentrado"
            @terminandoDetalle="terminandoDetalleConcentrado"
          >
          </reporte-concentrado-estimaciones>
        </v-card-text>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.reporteConcentradoEstimaciones.generarPdfDetalleConcentrado()"
            :loading="generandoPdfDetalleConcentrado"
          >
            <v-icon left> fa-file-pdf </v-icon>
            PDF Detalle
          </v-btn>
          <v-btn
            outlined
            @click="$refs.reporteConcentradoEstimaciones.generarPdfConcentrado()"
            :loading="generandoPdfConcentradoEstimaciones"
          >
            <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Reporte RELACION DE CONCEPTOS-->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarReporteRelacionConceptos"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          RELACIÓN DE CONCEPTOS
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="mostrarReporteRelacionConceptos = !mostrarReporteRelacionConceptos"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reporte-relacion-conceptos
            ref="reporteRelacionConceptos"
            :estimacion="estaEstimacion"
            :conceptos="getCatalogoConceptosPartidas"
            :contrato="getContrato"
            :firmas="getFirmasActivas"
            @generando="generandoRelacionConceptos"
            @terminando="terminandoRelacionConceptos"
          >
          </reporte-relacion-conceptos>
        </v-card-text>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.reporteRelacionConceptos.generarPdfRelacionConceptos()"
            :loading="generandoPdfRelacionConceptos"
          >
            <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Reporte PENAS CONVENCIONALES -->
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarReportePenasConvencionales"
      fullscreen
      hide-overlay
      scrollable
      persistent
    >
      <v-card color="#F2F6FF">
        <v-card-title class="d-print-none">
          PENAS CONVENCIONALES
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar"
          >
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <reporte-penas-convencionales
            ref="reportePenasConvencionales"
            :estimacion="estaEstimacion"
            :estimaciones="getEstimaciones"
            :contrato="getContrato"
            :firmas="getFirmasActivas"
            @generando="generandoPenasConvencionales"
            @terminando="terminandoPenasConvencionales"
          >
          </reporte-penas-convencionales>
        </v-card-text>
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            @click="$refs.reportePenasConvencionales.generarPdfPenasConvencionales()"
            :loading="generandoPdfPenasConvencionales"
          >
          <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
          <v-btn outlined @click="mandarImprimir">
            <v-icon left> fa-print </v-icon>
            Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="estaEstimacion"
      v-model="mostrarEliminarEstimacion"
      width="500"
    >
      <eliminar-estimacion
        :contratoEstimacionEliminar="estaEstimacion"
        v-on:cerrar="cerrar"
      />
    </v-dialog>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import eventBus from '@/helpers/eventBus';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';
import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import FIRMAS_POR_CONTRATO from '@/graphql/querys/administracion/contratos/firmas/firmasPorContrato.gql';
import CONTRATOS_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import CONTRATO_CATALOGO_CONCEPTOS_PARTIDAS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptosPartidas.gql';
import RegistrarNuevaEstimacion from '@/components/administracion/ejecucion/estimaciones/Nueva.vue';
import EditarEstimacion from '@/components/administracion/ejecucion/estimaciones/editar/Main.vue';
import EliminarEstimacion from '@/components/administracion/ejecucion/estimaciones/Eliminar.vue';
import ExportarExcelEstimaciones from '@/components/exportar/exceles/ExcelEstimaciones.vue';
import ExportarExcelFiniquito from '@/components/exportar/exceles/ExcelFiniquito.vue';
import CustomButton from '@/components/buttons/Button.vue';
import GraficaEstimadoAcumulado from '@/views/administracion/ejecucion/contrato/estimaciones/reportes/estimadoacumulado/Main.vue';
import ProgramaObraEstimaciones from '@/components/administracion/ejecucion/estimaciones/programaObras/programaObraEstimaciones.vue';
import Listado from './listado/Main.vue';
import GraficaAvanceEstimaciones from './reportes/graficaavanceestimaciones/Main.vue';
import ReporteControlEstimaciones from './reportes/controlestimaciones/Main.vue';
import ReporteConcentradoEstimaciones from './reportes/concentrado/Main.vue';
import ReportePenasConvencionales from './reportes/penasconvencionales/Main.vue';
import ReporteRelacionConceptos from './reportes/relacionconceptos/Main.vue';

export default {
  name: 'ContratoEstimacionesDefault',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [mixGenerarExceles],
  components: {
    Listado,
    RegistrarNuevaEstimacion,
    EditarEstimacion,
    EliminarEstimacion,
    GraficaEstimadoAcumulado,
    ProgramaObraEstimaciones,
    GraficaAvanceEstimaciones,
    ReporteControlEstimaciones,
    ReporteConcentradoEstimaciones,
    ReportePenasConvencionales,
    ReporteRelacionConceptos,
    CustomButton,
    ExportarExcelEstimaciones,
    ExportarExcelFiniquito,
  },
  data() {
    return {
      activarMostrarGrafica: true,
      estaCargando: false,
      mostrarRegistrarNuevaEstimacion: false,
      mostrarEditarEstimacion: false,
      mostrarEliminarEstimacion: false,
      mostrarEstimadoAcumulado: false,
      mostrarGraficaAvanceEstimaciones: false,
      mostrarProgramaObraEstimaciones: false,
      mostrarReporteControlEstimaciones: false,
      mostrarReporteConcentradoEstimaciones: false,
      mostrarReporteRelacionConceptos: false,
      mostrarReportePenasConvencionales: false,
      estaEstimacion: null,
      estimaciones: [],
      tipoLista: 0,
      generandoPdfGraficaEstimadoAcumulado: false,
      generandoPdfGraficaAvanceEstimaciones: false,
      generandoPdfControlEstimaciones: false,
      generandoPdfConcentradoEstimaciones: false,
      generandoPdfDetalleConcentrado: false,
      generandoPdfPenasConvencionales: false,
      generandoPdfRelacionConceptos: false,
    };
  },
  mounted() {
    eventBus.$on('ver-grafica-estimado-acumulado', (estimacion, estimaciones) => {
      this.mostrarEstimadoAcumulado = true;
      this.estaEstimacion = estimacion;
      this.estimaciones = estimaciones;
    });
    eventBus.$on('cerrar-ventana-programa-obra-estimaciones', () => {
      this.mostrarProgramaObraEstimaciones = false;
    });
    eventBus.$on('ver-programa-obra-estimaciones', (estimacion) => {
      this.mostrarProgramaObraEstimaciones = true;
      this.estaEstimacion = estimacion;
    });
    eventBus.$on('ver-grafica-avance-estimaciones', (estimacion) => {
      this.mostrarGraficaAvanceEstimaciones = true;
      this.estaEstimacion = estimacion;
    });
    eventBus.$on('ver-control-estimaciones', (estimacion) => {
      this.mostrarReporteControlEstimaciones = true;
      this.estaEstimacion = estimacion;
    });

    eventBus.$on('ver-concentrado-estimaciones', (estimacion) => {
      this.mostrarReporteConcentradoEstimaciones = true;
      this.estaEstimacion = estimacion;
    });

    eventBus.$on('ver-relacion-conceptos', (estimacion) => {
      this.estaEstimacion = estimacion;
      this.mostrarReporteRelacionConceptos = true;
    });

    eventBus.$on('ver-penas-convencionales', (estimacion) => {
      this.estaEstimacion = estimacion;
      this.mostrarReportePenasConvencionales = true;
    });

    eventBus.$on('editar-estimacion-contrato', (estimacion) => {
      this.mostrarEditarEstimacion = true;
      this.estaEstimacion = estimacion;
    });

    eventBus.$on('eliminar-estimacion-contrato', (estimacion) => {
      this.mostrarEliminarEstimacion = true;
      this.estaEstimacion = estimacion;
    });
  },
  methods: {
    mostrarGrafica() {
      this.activarMostrarGrafica = true;
    },
    generandoGraficaEstimadoAcumulado() {
      this.generandoPdfGraficaEstimadoAcumulado = true;
    },
    terminandoGraficaEstimadoAcumulado() {
      this.generandoPdfGraficaEstimadoAcumulado = false;
    },
    generandoGraficaAvanceEstimaciones() {
      this.generandoPdfGraficaAvanceEstimaciones = true;
    },
    terminandoGraficaAvanceEstimaciones() {
      this.generandoPdfGraficaAvanceEstimaciones = false;
    },
    generandoControlEstimaciones() {
      this.generandoPdfControlEstimaciones = true;
    },
    terminandoControlEstimaciones() {
      this.generandoPdfControlEstimaciones = false;
    },
    generandoConcentradoEstimaciones() {
      this.generandoPdfConcentradoEstimaciones = true;
    },
    terminandoConcentradoEstimaciones() {
      this.generandoPdfConcentradoEstimaciones = false;
    },
    generandoDetalleConcentrado() {
      this.generandoPdfDetalleConcentrado = true;
    },
    terminandoDetalleConcentrado() {
      this.generandoPdfDetalleConcentrado = false;
    },
    generandoPenasConvencionales() {
      this.generandoPdfPenasConvencionales = true;
    },
    terminandoPenasConvencionales() {
      this.generandoPdfPenasConvencionales = false;
    },
    generandoRelacionConceptos() {
      this.generandoPdfRelacionConceptos = true;
    },
    terminandoRelacionConceptos() {
      this.generandoPdfRelacionConceptos = false;
    },

    mandarImprimir() {
      window.print();
    },
    cerrar() {
      this.mostrarRegistrarNuevaEstimacion = false;
      this.mostrarEditarEstimacion = false;
      this.mostrarEliminarEstimacion = false;
      this.mostrarReporteControlEstimaciones = false;
      this.mostrarReporteConcentradoEstimaciones = false;
      this.mostrarReporteRelacionConceptos = false;
      this.mostrarReportePenasConvencionales = false;
      this.estaEstimacion = null;
    },
  },
  apollo: {
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables: {
        modulo: 'ejecucion',
      },
    },
    firmasPorContrato: {
      query: FIRMAS_POR_CONTRATO,
      variables() {
        return { idContrato: this.$route.params.idContrato };
      },
    },
    contratoConveniosModificatorios: {
      query: CONTRATOS_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoConceptosPartidas: {
      query: CONTRATO_CATALOGO_CONCEPTOS_PARTIDAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getCatalogoConceptosPartidas() {
      if (!this.contratoCatalogoConceptosPartidas) return [];
      return this.contratoCatalogoConceptosPartidas;
    },
    getConveniosModificatorios() {
      if (!this.contratoConveniosModificatorios) return [];
      return this.contratoConveniosModificatorios
        .filter((c) => c.fecha <= '30-05-2023')
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones
        .slice()
        .sort((a, b) => Number(a.numero) - Number(b.numero));
    },
    getEstimacionesAntesDeLaUltima() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones
        .filter(({ numero }) => numero < this.contratoEstimaciones.length)
        .slice()
        .sort((a, b) => Number(a.numero) - Number(b.numero));
    },
    getCatalogoConceptos() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos;
    },
    getContratoPrograma() {
      if (!this.contratoProgramasObra) return [];
      return this.contratoProgramasObra;
    },
    programa() {
      if (!this.contratoProgramasObra || this.contratoProgramasObra.length <= 0) return {};
      const [{ programa }] = this.contratoProgramasObra;
      const primerPrograma = programa
        .slice()
        .sort((a, b) => new Date(a.fechaTermino) - new Date(b.fechaTermino));
      const [programaInicial] = primerPrograma;
      const [programaFinal] = primerPrograma.reverse();
      return {
        programaInicial,
        programaFinal,
      };
    },
    existeEstimacionFiniquito() {
      if (!this.contratoEstimaciones) return false;
      return this.contratoEstimaciones.some(
        (contrato) => contrato.esEstimacionFiniquito === true,
      );
    },
    getFirmasPorContrato() {
      if (!this.firmasPorContrato) return [];
      return this.firmasPorContrato;
    },
    getFirmasPorModulo() {
      if (!this.firmasPorModulo) return [];
      return this.firmasPorModulo;
    },
    getFirmasActivas() {
      const firmasBase = this.getFirmasPorContrato && this.getFirmasPorContrato.length > 0
        ? this.getFirmasPorContrato
        : this.getFirmasPorModulo;

      if (!firmasBase || firmasBase.length <= 0) return [];

      const parseFecha = (valor) => {
        if (!valor) return null;
        if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;

        if (typeof valor === 'string') {
          const fecha = valor.trim();
          if (!fecha) return null;

          const formatoDiaMesAnio = fecha.match(/^(\d{2})-(\d{2})-(\d{4})$/);
          if (formatoDiaMesAnio) {
            const [, dia, mes, anio] = formatoDiaMesAnio;
            const normalizada = `${anio}-${mes}-${dia}`;
            const fechaParseada = new Date(normalizada);
            return Number.isNaN(fechaParseada.getTime()) ? null : fechaParseada;
          }

          const fechaParseada = new Date(fecha);
          return Number.isNaN(fechaParseada.getTime()) ? null : fechaParseada;
        }

        return null;
      };

      const tieneOrdenDuplicado = firmasBase
        .map((firma) => firma.orden)
        .some((orden, index, arr) => arr.indexOf(orden) !== index);

      if (!tieneOrdenDuplicado) return firmasBase;

      const fechaPresentacion = parseFecha(
        this.estaEstimacion && this.estaEstimacion.fechaPresentacion,
      );

      const firmasPorOrden = firmasBase.reduce((acumulador, firma) => {
        const key = String(firma.orden);
        return {
          ...acumulador,
          [key]: acumulador[key]
            ? [...acumulador[key], firma]
            : [firma],
        };
      }, {});

      return Object.keys(firmasPorOrden)
        .sort((a, b) => Number(a) - Number(b))
        .map((orden) => {
          const firmasOrden = firmasPorOrden[orden];
          if (firmasOrden.length === 1) return firmasOrden[0];

          const candidatas = fechaPresentacion
            ? firmasOrden.filter((firma) => {
              const fechaNombramiento = parseFecha(
                firma.funcionario && firma.funcionario.fechaNombramiento,
              );
              return fechaNombramiento && fechaPresentacion >= fechaNombramiento;
            })
            : firmasOrden;

          const fuente = candidatas.length > 0 ? candidatas : firmasOrden;

          return fuente.slice().sort((a, b) => {
            const fechaA = parseFecha(a.funcionario && a.funcionario.fechaNombramiento);
            const fechaB = parseFecha(b.funcionario && b.funcionario.fechaNombramiento);

            const valorA = fechaA ? fechaA.getTime() : 0;
            const valorB = fechaB ? fechaB.getTime() : 0;

            return valorB - valorA;
          })[0];
        });
    },
  },
  watch: {
    tipoLista: {
      handler(val) {
        eventBus.$emit('estimaciones-cambiar-tipo-lista', val);
      },
    },
  },
};
</script>

<style lang="scss">
</style>
